module.exports = __webpack_public_path__ + "static/media/grow.727542b0.png";